'use client';

import { useTranslations } from 'next-intl';
import { SecondaryNavbar_Rare } from './SecondaryNavbar_Rare';
import { getRareSections } from 'components/shared/SecondaryNavbarConfigs';
import { useEffect } from 'react';

export const RareSecondaryNavbar = () => {
  const t = useTranslations('ring');
  const rareSections = getRareSections(t);

  useEffect(() => {
    // Debug: Check if all sections exist in DOM
    Object.values(rareSections).forEach((section) => {
      const element = document.getElementById(section.id);
      console.log(`Section ${section.id}:`, element ? 'Found' : 'Not found');
    });
  }, [rareSections]);

  return <SecondaryNavbar_Rare />;
};
